define('modules/User/DefaultShippingFlags',[
        'jquery',
        'global/all',
        'plugins/jquery.proxyRequest'
],
    function ($, Roc) {
        'use strict';

        function setDefaultShippingMethod(shippingMethodName) {
            return $.proxyRequest({
                type: 'POST',
                contentType: 'application/json; charset=utf-8',
                url: 'api/customershippingflags/defaultshippingmethod/' + shippingMethodName,
                complete: function (xhr) {
                    Roc.Logger.info('DefaultShippingFlags -> setDefaultShippingMethod');
                    Roc.Logger.info(xhr);
                }
            });
        }

        function getUserDefaultShippingOption() {
            var deferred = $.Deferred();
            $.proxyRequest({
                type: 'GET',
                contentType: 'application/json; charset=utf-8',
                url: 'api/customershippingflags/user',
                dataType: 'json',
                complete: function (xhr) {
                    Roc.Logger.info('DefaultShippingFlags -> getUserDefaultShippingOption');
                    Roc.Logger.info(xhr);
                    if (xhr.status === 200) {
                        var response = xhr.responseJSON || {};
                        deferred.resolve(response);
                    } else {
                        deferred.reject('An unexpected error has occured when getting default shipping option .');
                    };
                }
            });
            return deferred.promise();
        }

        function getOrganizationDefaultShippingOption(organizationId) {
            var deferred = $.Deferred();
            $.proxyRequest({
                type: 'GET',
                contentType: 'application/json; charset=utf-8',
                url: 'api/customershippingflags/' + organizationId,
                dataType: 'json',
                complete: function (xhr) {
                    Roc.Logger.info('DefaultShippingFlags -> getOrganizationDefaultShippingOption');
                    Roc.Logger.info(xhr);
                    if (xhr.status === 200) {
                        var response = xhr.responseJSON || {};
                        deferred.resolve(response);
                    } else {
                        deferred.reject('An unexpected error has occured when getting default shipping option .');
                    };
                }
            });
            return deferred.promise();
        }

        var DefaultShippingFlags = {
            setDefaultShippingMethod: setDefaultShippingMethod,
            getUserDefaultShippingOption: getUserDefaultShippingOption,
            getOrganizationDefaultShippingOption: getOrganizationDefaultShippingOption
        };

        Roc.Logger.debug('DefaultShippingFlags.js Loaded:', DefaultShippingFlags);

        return DefaultShippingFlags;


    });
